import styled from "styled-components";

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
  border-radius: 8px;
  padding: 20px 25px;

  .recharts-text .recharts-cartesian-axis-tick-value {
    dy: -3;
  }
`;

export const Title = styled.div`
  font-family: "Orkney Bold";
  font-size: 16px;
  line-height: 18px;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  anticon {
    line-height: 0px;
    height: 10px;
  }
`;

export const Graph = styled.div`
  height: 100%;
  width: ${(props: { isLoss: boolean }) => (props.isLoss ? "85%" : "80%")};
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const GraphTitle = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-left: ${(props: { isCounter?: boolean }) =>
    !props.isCounter && "100px"};
  font-family: Orkney Medium;
`;

export const GraphListContainer = styled.div`
  display: flex;
`;

export const List = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding-right: 2em;
`;

export const ListValue = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-align: end;
  padding-top: 7px;
  padding-bottom: 7px;
  font-weight: 500;
  color: #111111;
`;

export const ListValueApplicants = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-align: end;
  padding-top: 6px;
  padding-bottom: 4.5px;
  font-weight: 500;
  color: #111111;
`;

export const GraphText = styled.text`
  font-size: 12px;
  font-weight: 500;
  color: #111111;
`;
